import { Component } from '@angular/core';

@Component({
  selector: 'app-user-otp',
  templateUrl: './user-otp.component.html',
  styleUrls: ['./user-otp.component.css']
})
export class UserOtpComponent {

}
